import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Defs, Path, Pattern, Rect, Use, Image } from 'react-native-svg';
const beeAssessmentIcon = require('../images/beeAssessment.png');

const BeeBuzzGameHexagon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 79}
          height={props.height ?? 88}
          viewBox="0 0 79 88"
          fill="none"
          {...props}
        >
          <Rect
            x="37.1367"
            y="15.6641"
            width="41.0406"
            height="71.2222"
            fill="url(#pattern0_1_39128)"
          />
          <Path
            d="M72.3255 69.0019C74.6443 67.6512 76.5234 64.2949 76.5234 61.5527L76.5234 26.4351C76.5234 23.6928 74.6443 20.3775 72.3255 18.9859L42.6199 1.42707C40.301 0.0763917 36.5428 0.0763915 34.2239 1.42707L4.51828 18.9859C2.1994 20.3366 0.320312 23.6928 0.320311 26.4351L0.32031 61.5527C0.32031 64.2949 2.1994 67.6102 4.51828 69.0019L34.2239 86.5606C36.5428 87.9113 40.301 87.9113 42.6199 86.5606L72.3255 69.0019Z"
            fill="#FFB600"
            fillOpacity="0.22"
          />
          <Defs>
            <Pattern
              id="pattern0_1_39128"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <Use
                xlinkHref="#image0_1_39128"
                transform="matrix(0.00399864 0 0 0.00230415 -0.0258208 0)"
              />
            </Pattern>
            <Image
              id="image0_1_39128"
              width="263"
              height="434"
              preserveAspectRatio="none"
              xlinkHref={beeAssessmentIcon}
            />
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { BeeBuzzGameHexagon };
